import {ChangeDetectionStrategy, Component, computed, input, output} from '@angular/core';
import {AppNumberPipe} from '@frontend/shared';
import {TranslocoPipe} from '@jsverse/transloco';
import {Tooltip} from 'primeng/tooltip';
import {RfiCoverage} from '../step-5-3-rfi-invitation-list.types';
import {coverageBarClass} from '../rfi-coverage-analysis-dialog/rfi-coverage-analysis.model';
import {RfiCoverageBarComponent} from '../rfi-coverage-bar/rfi-coverage-bar.component';
import {RfiAnalysisInfoButtonComponent} from '../rfi-analysis-info-button/rfi-analysis-info-button.component';

@Component({
  selector: 'app-rfi-coverage-cell',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AppNumberPipe,
    TranslocoPipe,
    Tooltip,
    RfiCoverageBarComponent,
    RfiAnalysisInfoButtonComponent,
  ],
  templateUrl: './rfi-coverage-cell.component.html',
})
export class RfiCoverageCellComponent {
  readonly coverage = input<RfiCoverage | undefined>(undefined);

  readonly analysisRequested = output<void>();

  protected readonly score = computed(() => this.coverage()?.totalCoverage ?? 0);
  protected readonly hasGaps = computed(() => this.coverage()?.hasGaps ?? false);
  protected readonly barClass = computed(() => coverageBarClass(this.score()));
}
